'use strict';

var hasOverflow = require('./has-overflow');

var scrollParent = function scrollParent(element) {

  if (!(element instanceof HTMLElement)) {
    return window;
  }

  while (element.parentNode) {
    if (element.parentNode === document.body) {
      return window;
    }

    if (hasOverflow(element.parentNode)) {
      return element.parentNode;
    }
    element = element.parentNode;
  }
  return window;
};

module.exports = scrollParent;


//////////////////
// WEBPACK FOOTER
// ./~/scrollfeatures/lib/scroll-parent.js
// module id = 68
// module chunks = 24564523585802 77757019989577 88899200817339 114276838955818 159264293819137 170425996347293 257404837723318 262202390628140